<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
  padding: 16px 0px;
}
.ml22 {
  margin-left: 22px;
}
.ml28 {
  margin-left: 28px;
}
</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION Paid Service Agreement</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">Release Date: August 1, 2025</p>
      <p class="pt8 fw700">Effective Date: August 1, 2025</p>

      <div class="section-title">1. Service Content</div>
      <p class="ml22">1.1 Service Types</p>
      <ul>
        <li>Instant Text Translation: Direct text input and translation via web interface</li>
        <li>Real-time Voice Translation: Interactive voice translation via microphone input</li>
        <li>API Call Service: Access translation services through web API interfaces</li>
      </ul>

      <div class="section-title">Account & Subscription</div>
      <p class="ml22">2.1 Account Registration</p>
      <ul>
        <li>Web account registration via email/mobile number</li>
        <li>Enterprise users must provide business license copy (PDF format)</li>
      </ul>
      <p class="ml22">2.2 Subscription Plans</p>
      <p>Current subscription options are displayed in real-time on the subscription interface.</p>

      <div class="section-title">3. Payment & Settlement</div>
      <p class="ml22">3.1 Payment Methods</p>
      <ul>
        <li>Credit Card: Processed via Stripe (Visa/Mastercard/Amex)</li>
        <li>Alipay: Instant payment</li>
        <li> Bank Transfer: Enterprise users only (3-5 business days processing)</li>
      </ul>
      <p class="ml22">3.2 Invoice Issuance</p>
      <ul>
        <li>Contact customer service at <a href="">admin@xrion.ai </a> for invoice requests after purchase</li>
      </ul>

      <div class="section-title">4. Service Usage Rules</div>
      <p class="ml22">4.1 Browser Support</p>
      <ul>
        <li>Recommended: Chrome 90+/Firefox 85+/Edge 90+</li>
        <li>IE browser compatibility not guaranteed</li>
      </ul>
      <p class="ml22">4.2 Data Security</p>
      <ul>
        <li>All web transmissions use TLS 1.3 encryption</li>
        <li>User-submitted original text is immediately deleted from servers after translation</li>
      </ul>

      <div class="section-title">5. API Service Terms</div>
      <p class="ml22">5.1 Call Limits</p>
      <ul>
        <li>Subject to purchased subscription plan limits</li>
      </ul>
      <p class="ml22">5.2 Usage Requirements</p>
      <ul>
        <li>Must include "XRION-API" in User-Agent</li>
        <li>IP address spoofing prohibited</li>
      </ul>

      <div class="section-title">6. Refund Policy</div>
      <p class="ml22">6.1 Eligible Cases</p>
      <ul>
        <li> 7-day no-questions-asked refund for new users</li>
      </ul>
      <p class="ml22">
        6.2 Refund Processing
      </p>
      <p class="ml22">Contact customer service at <a href="">admin@xrion.ai</a></p>

      <div class="section-title">7. Service Termination</div>
      <p class="ml22">7.1 User-initiated termination via account cancellation</p>
      <p class="ml22">7.2 Automatic service suspension upon subscription expiration or quota depletion</p>
      <p class="ml22">7.3 XRION may terminate service for violations (e.g., malicious scraping)</p>

      <div class="section-title">8. Technical Support</div>
      <p class="ml22">Customer Service Email:<a href="">admin@xrion.ai</a></p>

      <p class="fw700 p16">Important Notes:</p>
      <p class="fw700 ">1.Avoid saving login status on public computers</p>
      <p class="fw700 ">2.Change account password regularly</p>
      <p class="fw700 ">3.Enterprise users should utilize IP whitelisting</p>
      <p class="fw700 p16">
        This Agreement supplements the XRION User Agreement. In case of conflict, this Agreement prevails. Continued use constitutes acceptance of all terms.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaidServiceAgreementEn",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
